<template>
  <div>
    <v-icon v-if="params.value" color="success" small>far fa-check-circle</v-icon>
    <v-icon v-if="!params.value" color="error" small>far fa-times-circle</v-icon>
  </div>
</template>

<script>
    import Vue from 'vue';

    export default Vue.extend({
        
    });
</script>

<style >
</style>



// WEBPACK FOOTER //
// src/components/shared/CheckComponent.vue